import { UserInfo } from "./UserInfo";
import { CasinoPlayerActivity } from "./CasinoPlayerActivity";
import { CasinoPlayerActivity as CasinoPlayerActivityLayer } from "sb-data-layer";
Object.assign(window.UserInfo.prototype, UserInfo.prototype);
if (window.InactivityLogoutMinutes) {
    window.casinoPlayerActivity = new CasinoPlayerActivity(window.Application, window.InactivityLogoutMinutes, new CasinoPlayerActivityLayer.connection({}));
}
//# sourceMappingURL=index.js.map